export const wholeHouseFoundationIds = [
	// [ROME-8189]
	'wholeHouseFoundationCMUBlock',
	// [ROME-3434]
	'wholeHouseFoundationFormMaterial',
	'wholeHouseFoundationRebar',
	'wholeHouseFoundationVaporBarrier',
	// [ROME-6133]  // TO be added to US templates
	'wholeHouseFoundationConcreteYardage',
	'wholeHouseFoundationEmbeddedHardware',
] as const;

export const wholeHouseFoundationBasementIds = [
	'wholeHouseFoundationBasementFormMaterial',
	'wholeHouseFoundationBasementRebar',
	'wholeHouseFoundationBasementVaporBarrier',
	'wholeHouseFoundationBasementConcreteYardage',
	'wholeHouseFoundationBasementEmbeddedHardware',
] as const;

export const wholeHouseFramingIds = [
	// [ROME-6133]  // TO be added to US templates
	'wholeHouseFramingWallFraming',
	'wholeHouseFramingFloorAndCeilingSystemFraming',
	'wholeHouseFramingRoofSystemFraming',
	'wholeHouseFramingStructuralHeadersBeamsPostsColumns',
	'wholeHouseFramingDeckAndPorchFraming',
] as const;

export const wholeHouseDecksAndPorchesIds = [
	// [ROME-3434]
	'wholeHouseDecksAndPorchesFraming',
	'wholeHouseDecksAndPorchesSheathing',
	'wholeHouseDecksAndPorchesAnchorage',
	'wholeHouseDecksAndPorchesOthers',
] as const;

export const wholeHouseExteriorFinishesIds = [
	// [ROME-3434
	'wholeHouseExteriorFinishesSiding',
	'wholeHouseExteriorFinishesBrickOrStone',
	'wholeHouseExteriorFinishesFinishedFascia',
	'wholeHouseExteriorFinishesOthers',
	// ROME-6133  // TO be added to US templates
	'wholeHouseExteriorFinishesWoodSidingAndTrim',
	'wholeHouseExteriorFinishesCompositeEngineeredSidingAndTrim',
	'wholeHouseExteriorFinishesExteriorFeatures',
] as const;

export const wholeHouseEwpFloorRoofLayoutIds = [
	// ROME-6133  // TO be added to US templates
	'wholeHouseEwpFloorRoofLayoutFloorJoistLayout',
	'wholeHouseEwpFloorRoofLayoutCeilingJoistLayout',
	'wholeHouseEwpFloorRoofLayoutRoofRafterLayout',
	'wholeHouseEwpFloorRoofLayoutHeadersBeamsLayout',
] as const;

export const wholeHouseInteriorFinishesIds = [
	// [ROME-3434
	'wholeHouseInteriorFinishesPaint',
	'wholeHouseInteriorFinishesCabinets',
	'wholeHouseInteriorFinishesCountertops',
	'wholeHouseInteriorFinishesCarpet',
	'wholeHouseInteriorFinishesTile',
	'wholeHouseInteriorFinishesVinyl',
	'wholeHouseInteriorFinishesOthers',
] as const;

export const wholeHouseDimensionalFloorRoofLayoutIds = [
	// ROME-6133  // TO be added to US templates
	'wholeHouseDimensionalFloorRoofLayoutFloorJoistLayout',
	'wholeHouseDimensionalFloorRoofLayoutCeilingJoistLayout',
	'wholeHouseDimensionalFloorRoofLayoutRoofRafterLayout',
	'wholeHouseDimensionalFloorRoofLayoutHeadersBeamsLayout',
] as const;

export const wholeHouseOpeningsIds = [
	// ROME-6133  // TO be added to US templates
	'wholeHouseOpeningsExteriorDoorsAndWindows',
	'wholeHouseOpeningsInteriorDoors',
] as const;

export const wholeHouseRoofingIds = [
	// ROME-6133  // TO be added to US templates
	'wholeHouseRoofingAsphaltShingles',
	'wholeHouseRoofingConcreteClayComposite',
	'wholeHouseRoofingMetal',
	'wholeHouseRoofingAncillariesUnderlaymentIceAndWaterShield',
] as const;

export const wholeHouseFlatRoofingIds = [
	// ROME-6133  // TO be added to US templates
	'wholeHouseFlatRoofingTPOEPDM', //Thermoplastic Polyolefin & Ethylene Propylene Diene Monomer
	'wholeHouseFlatRoofingAncillariesUnderlaymentIceAndWaterShield',
] as const;

export const ids = [
	...wholeHouseFoundationIds,
	...wholeHouseFoundationBasementIds,
	...wholeHouseFramingIds,
	...wholeHouseDecksAndPorchesIds,
	...wholeHouseEwpFloorRoofLayoutIds,
	...wholeHouseDimensionalFloorRoofLayoutIds,
	...wholeHouseExteriorFinishesIds,
	...wholeHouseInteriorFinishesIds,
	...wholeHouseOpeningsIds,
	...wholeHouseRoofingIds,
	...wholeHouseFlatRoofingIds,
] as const;
